module.exports = __webpack_public_path__ + "static/media/24.9b9f0a5f.mp3";